// One creation affordance: pick a recurring template or type your own, and
// give it a due date. The date is required -- a task is created WITH its date
// (spec §2.1), so there is no undated task to sort nowhere.
import React, { useState } from 'react';

export default function AddTaskDialog({ templates, openKeys, onCancel, onSubmit, saving }) {
  const [key, setKey] = useState('');
  const [title, setTitle] = useState('');
  const [due, setDue] = useState('');
  const [note, setNote] = useState('');
  const custom = key === '__custom__';
  const ready = !!due && (custom ? !!title.trim() : !!key);

  const submit = (e) => {
    e.preventDefault();
    if (!ready || saving) return;
    onSubmit({
      template_key: custom ? null : key,
      title: custom ? title.trim() : null,
      due_at: due,
      note: note.trim() || null,
    });
  };

  return (
    <form className="cn-dialog" onSubmit={submit} data-testid="add-task-dialog">
      <h4 className="cn-dialog__title">Add task</h4>
      <div className="cn-dialog__choices">
        {templates.map(t => {
          const taken = openKeys.includes(t.key);
          return (
            <label key={t.key} className={`cn-choice${taken ? ' cn-choice--taken' : ''}`}>
              <input type="radio" name="cn-add-task" aria-label={t.title} value={t.key}
                     disabled={taken} checked={key === t.key}
                     onChange={() => setKey(t.key)} />
              <span>{t.title}</span>
              {taken && <span className="cn-choice__taken">already on the list</span>}
            </label>
          );
        })}
        <label className="cn-choice">
          <input type="radio" name="cn-add-task" aria-label="Something else…" value="__custom__"
                 checked={custom} onChange={() => setKey('__custom__')} />
          <span>Something else…</span>
        </label>
      </div>
      {custom && (
        <label className="ae-field">
          <span className="ae-field__label">Task</span>
          <input className="ae-field__input" aria-label="Task" value={title}
                 placeholder="e.g. Get transcript from counselor"
                 onChange={e => setTitle(e.target.value)} />
        </label>
      )}
      <label className="ae-field">
        <span className="ae-field__label">Due date</span>
        <input className="ae-field__input" type="date" aria-label="Due date" value={due}
               onChange={e => setDue(e.target.value)} />
      </label>
      <label className="ae-field">
        <span className="ae-field__label">Note (optional)</span>
        <textarea className="ae-field__input" aria-label="Note" rows={2} value={note}
                  onChange={e => setNote(e.target.value)} />
      </label>
      <div className="cn-dialog__actions">
        <button type="submit" className="cn-btn" disabled={!ready || saving}>Add task</button>
        <button type="button" className="cn-todo__action" onClick={onCancel}>Cancel</button>
      </div>
    </form>
  );
}
